/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function ACG(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                viewBox='0 0 25.01 25.01'
                xmlns='http://www.w3.org/2000/svg'
            >
                <title>ACG_Number</title>
                <g
                    data-name='Layer 2'
                    id='Layer_2'
                >
                    <g
                        data-name='Layer 1'
                        fill={iconColor || '#000'}
                        id='Layer_1-2'
                    >
                        <path d='M6.48,25H.5A.51.51,0,0,1,0,24.5V9.14a.51.51,0,0,1,.5-.5h6a.5.5,0,0,1,.5.5V24.5A.5.5,0,0,1,6.48,25ZM1,24H6V9.65H1Z' />
                        <path d='M15.49,25h-6A.51.51,0,0,1,9,24.5V5.3a.51.51,0,0,1,.51-.5h6a.51.51,0,0,1,.51.5V24.5A.51.51,0,0,1,15.49,25ZM10,24h5V5.81H10Z' />
                        <path d='M24.5,25h-6A.51.51,0,0,1,18,24.5V.5a.51.51,0,0,1,.51-.5h6A.51.51,0,0,1,25,.5v24A.51.51,0,0,1,24.5,25ZM19,24h5V1H19Z' />
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}